export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RegionToolbar.vue?vue&type=template&id=1aa370c8&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/annotations/annotations-ui/RegionToolbar.vue?vue&type=template&id=1aa370c8&scoped=true&
// module id = 390
// module chunks = 0